import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/caikuma_jumping.svg?webp'


const _withScopeId = n => (_pushScopeId("data-v-a25bdbb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-started" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"description\" data-v-a25bdbb0><h3 class=\"description-title\" data-v-a25bdbb0>出勤処理が完了しました</h3> <div class=\"description-content\" data-v-a25bdbb0><p data-v-a25bdbb0>お仕事頑張ってください！</p></div> <div class=\"description-image\" data-v-a25bdbb0><img src=\"" + _imports_0 + "\" alt=\"カイクマ\" class=\"caikuma\" data-v-a25bdbb0></div></div>", 1)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "退勤後に勤怠変更申請が必要な可能性があります", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "退勤後、画面に沿って操作をお願いします", -1))
const _hoisted_6 = { class: "bottom" }

import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import CautionContainer from "@/components/molecules/CautionContainer.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { applicationService } from "@/app/services/ApplicationService";
import { Application } from "@/types/order/Application";
import { addMinutes, now, parseISO, subMinutes } from "@/utils/date";
import { useCustomRouter } from "@/utils/router";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkStarted',
  setup(__props) {

const route = useRoute();
const loader = useLoader();
const { pushIgnoreError } = useCustomRouter();
const { showErrorModal } = useErrorModal();
const application = ref<Application | null>(null);

const applicationId = computed(() => route.params.applicationId);

const isDiscrepancyStartWorkTime = computed(() => {
  if (!application.value) {
    return false;
  }
  // 予定の開始時間より30分以上早い、または5分以上遅れていれば true
  const startTime = parseISO(application.value.appliedStartWorkAt);
  const nowTime = now();
  return (
    nowTime <= subMinutes(startTime, 30) || nowTime >= addMinutes(startTime, 5)
  );
});

async function onBackApplicationList() {
  await pushIgnoreError({ name: "ApplicationsList" });
}

async function fetchApplication() {
  application.value = await applicationService.fetchApplication(
    Number(applicationId.value)
  );
}

onMounted(async () => {
  try {
    loader.show();
    await fetchApplication();
  } catch (error) {
    showErrorModal(error as Error);
  } finally {
    loader.hide();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(),
      (isDiscrepancyStartWorkTime.value)
        ? (_openBlock(), _createBlock(CautionContainer, { key: 0 }, {
            title: _withCtx(() => [
              _createTextVNode("出勤時間にズレがあります")
            ]),
            content: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(),
              _hoisted_5
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(AppButton, {
        block: "",
        onClick: onBackApplicationList
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n        仕事管理に戻る\n      ")
        ], undefined, true),
        _: 1
      })
    ]),
    _createTextVNode(),
    _createVNode(BlockBack)
  ]))
}
}

})